import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MessageCircle, Phone } from 'lucide-react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { SocialLinks } from '../components/SocialLinks';
import { media } from '../data/media';
import { CONTACT_EMAIL, CONTACT_EMAIL_HREF, CONTACT_PHONE_DISPLAY, CONTACT_PHONE_HREF, INSTAGRAM_URL } from '../data/contact';
import { useLanguage } from '../contexts/LanguageContext';
export function Evenements() {
  const {
    t
  } = useLanguage();
  return <>
      <PageHeader eyebrow={t.events.eyebrow} titleLead={t.events.titleLead} titleAccent={t.events.titleAccent} intro={t.events.intro} data-id="element-354" data-mp="1994f6amwpbt4" />

      <section className="bg-creme py-20 md:py-28" data-id="element-355" data-mp="1i5wpwn6140kb">
        <div className="mx-auto max-w-7xl px-6 md:px-12" data-id="element-356" data-mp="2yl6kedciqg9g">
          <div className="grid gap-14 lg:grid-cols-2 lg:items-center" data-id="element-357" data-mp="2ynssqf78gzsq">
            <div className="grid gap-6 sm:grid-cols-2" data-id="element-358" data-mp="2tlto71zrbwu7">
              {t.events.offerings.map((offering, index) => <motion.article key={offering.title} initial={{
              opacity: 0,
              y: 24
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-80px'
            }} transition={{
              duration: 0.6,
              delay: index * 0.1
            }} className="border border-caramel/25 bg-creme-dark p-7" data-id="element-359" data-mp="aqk9sf51chq2" data-mpi={index}>
                  <h2 className="mb-3 font-serif text-lg text-cacao-900" data-id="element-360" data-mp="3na1vj60j0cp7">
                    {offering.title}
                  </h2>
                  <p className="font-sans text-sm font-light leading-relaxed text-cacao-700" data-id="element-361" data-mp="110lgtyjzvnt">
                    {offering.text}
                  </p>
                </motion.article>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 28
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.7
          }} className="border border-or/40 p-3" data-id="element-362" data-mp="34i90l61wcheu">
              <img src={media.giftBoxes} alt="Coffrets cadeaux avec bonbons de chocolat et barres artisanales" className="aspect-[4/5] w-full object-cover" data-id="element-363" data-mp="2xesrerhvbpzq" />
            </motion.div>
          </div>
        </div>
      </section>

      <section className="bg-cacao-900 py-20 md:py-24" data-id="element-364" data-mp="2iha8i5rvg707">
        <div className="mx-auto max-w-3xl px-6 text-center md:px-12" data-id="element-365" data-mp="2ihsbdl91hjh3">
          <h2 className="mb-6 font-serif text-2xl text-creme md:text-3xl" data-id="element-366" data-mp="2eggklcefis7b">
            {t.events.ctaTitle}
          </h2>
          <p className="mb-10 font-sans font-light leading-relaxed text-creme/75" data-id="element-367" data-mp="2sg95gr39ye7d">
            {t.events.ctaText}
          </p>

          <div className="mb-10 flex flex-col items-center justify-center gap-5 sm:flex-row" data-id="element-368" data-mp="2nig2e6x9q0bb">
            <a href={CONTACT_PHONE_HREF} className="flex items-center gap-3 font-sans text-sm text-caramel-light transition-colors hover:text-creme" data-id="element-369" data-mp="7rbpbxrgt696">
              <Phone size={17} strokeWidth={1.5} aria-hidden="true" data-id="element-370" data-mp="1kmfy9f8c4eyn" />
              {CONTACT_PHONE_DISPLAY}
            </a>
            <span aria-hidden="true" className="hidden h-4 w-px bg-or/40 sm:block" data-id="element-371" data-mp="1bn2m2esttca8" />
            <a href={CONTACT_EMAIL_HREF} className="flex items-center gap-3 break-all font-sans text-sm text-caramel-light transition-colors hover:text-creme" data-id="element-372" data-mp="1glno8jrn261b">
              <Mail size={17} strokeWidth={1.5} aria-hidden="true" data-id="element-373" data-mp="28dv6tpqpfsic" />
              {CONTACT_EMAIL}
            </a>
          </div>

          <div className="mb-10 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-374" data-mp="1ulf8v3cnukoa">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-caramel px-8 py-4 font-sans text-xs uppercase tracking-[0.16em] text-creme transition-colors duration-300 hover:bg-caramel-light" data-id="element-375" data-mp="1zjqgd7fhgj3c">
              <MessageCircle size={16} strokeWidth={1.5} aria-hidden="true" data-id="element-376" data-mp="13gt55wb6akui" />
              {t.events.dmCta}
            </a>
            <Link to="/contact" className="border border-caramel-light px-8 py-4 font-sans text-xs uppercase tracking-[0.16em] text-caramel-light transition-colors duration-300 hover:border-creme hover:text-creme" data-id="element-377" data-mp="yirhsz6przd8">
              {t.events.cta}
            </Link>
          </div>

          <div className="flex justify-center" data-id="element-378" data-mp="1i3w0bwc0wheo">
            <SocialLinks variant="light" data-id="element-379" data-mp="1i57g6uiqtfm5" />
          </div>
        </div>
      </section>
    </>;
}